import React, { useEffect, useMemo, useState } from "react";
import { Box, Tabs, Tab, FormLabel } from "@mui/material";
import CommonIcon from "../../helpers/icons";
import CustomListView from "../MUIDataTable/CustomListView";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import {
  getApplication,
  roleBasedUsers,
  unAssignedUsers,
  userRemoveTable,
  userRoleAssign,
} from "../../../action/ApplicationApi";
import Actions from "../../../action/api";
import API from "../../helpers/endpointservice";
import {
  Autocomplete,
  Avatar,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CustomListViewSub from "../MUIDataTable/ListViewSub";

export default function TenantAdminSettings() {
  // ----------- Dummy Data -----------
  const [totalLicense, setTotalLicense] = useState(0);
  const [assignedLicenses, setAssignedLicenses] = useState(0);
  const [availableLicense, setAvailableLicense] = useState(0);
  const [clientId, setClientId] = useState("");

  const [subscriptionStatus, setSubscriptionStatus] = useState("Trial");
  const [isTenantAdminCenter, setIsTenantAdminCenter] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const [rolebasedId, setRolebasedId] = useState("");

  const [applicationroles, setApplicationRoles] = useState([]);

  const [search, setSearch] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [currentFilters, setCurrentFilters] = useState(null);
  const [selectedUserssss, setSelectedUserssss] = useState([]);
  const [userError, setUserError] = useState(false);

  const [roleBasedUsersData, steRoleBasedUserData] = useState([]);

  const [applicationId, setApplicationId] = useState("");
  const [unassignedUsers, setUnassignedUsers] = useState([]);

  const [tableLoader, setTableLoader] = useState(false);
  const [totalCount] = useState(2);
  const dispatch = useDispatch();

  const handleUserChange = (event, value) => {
    setSelectedUserssss(value);
    console.log(value);
    setUserError(value.length === 0);
  };

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDeleteOpen, setIsdeleteOpen] = useState(false);
  const [currentDeleteValue, setCurrentDeleteValue] = useState(null);
  const [isSSO, setIsSSO] = useState(false);

  const getIsSSO = () => {
    Actions.GET(API.IsSSO)
      .then((res) => {
        setIsSSO(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const closeUserGroupForm = () => {
    setSelectedUserssss([]);
    setUserError(false);
    setIsAddOpen(false);
  };

  useEffect(() => {
    getIsSSO();
    let isMounted = true;
    const loadTenant = async () => {
      try {
        dispatch({ type: "IS_LOADER", data: true });
        const res = await Actions.GET(API.GetTenantAdminId);
        const id = res?.data;
        if (isMounted) {
          setApplicationId(id);
          fetchDetails(id);
        }
      } catch (error) {
        dispatch({ type: "IS_LOADER", data: false });
        console.error("Failed to load tenant ID:", error);
      }
    };

    loadTenant();

    return () => {
      isMounted = false; // cleanup
    };
  }, []);

  const fetchDetails = (id) => {
    dispatch(getApplication(id))
      .then((response) => {
        if (response.data) {
          setTotalLicense(response?.data?.license?.totalLicenses || 0);
          setAssignedLicenses(response?.data?.license?.assingedLicenses || 0);
          setAvailableLicense(response?.data?.license?.availableLicenses || 0);
          setApplicationRoles(response?.data?.roles || []);
          setRolebasedId(response?.data?.roles[0]?.id || "");
          setClientId(response?.data?.clientId || "");
          setIsDataFetched(true);
          setSubscriptionStatus(
            response.data?.purchaseInfo?.subscriptionStatus || ""
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
    dispatch(unAssignedUsers(id))
      .then((res) => {
        if (res.data) {
          setUnassignedUsers(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const AssignRoles = () => {
    let roleName =
      applicationroles.find((role) => role.id === rolebasedId)?.name || "";
    let data = {};
    if (!isSSO) {
      data = selectedUserssss.map((userData, index) => ({
        client_id: clientId,
        roleName: roleName,
        email: userData.email,
        userId: userData.id,
        groupName: userData.name || "",
        type: userData.type,
        groupId: userData.id || "",
      }));
    } else {
      data = selectedUserssss.map((userData, index) => ({
        client_id: clientId,
        roleName: roleName,
        email: userData.email,
        type: userData.type,
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        managerEmail: userData.managerEmail || "",
      }));
    }
    console.log(data);
    if (selectedUserssss.length > 0) {
      setUserError(false);
      dispatch({ type: "IS_LOADER", data: true });
      dispatch(userRoleAssign(applicationId, rolebasedId, data,null,isSSO))
        .then((res) => {
          closeUserGroupForm();
          fetchDetails(applicationId);
          handleDataFetch(
            currentFilters.pageSize,
            currentFilters.pageIndex,
            currentFilters.columnFilter,
            currentFilters.sortingFilters
          );
        })
        .catch((error) => {
          console.log(error);
          dispatch({ type: "IS_LOADER", data: false });
        });
    } else {
      setUserError(true);
    }
  };

  const handleDelete = (value) => {
    let roleNames =
      applicationroles.find((role) => role.id === rolebasedId)?.name || "";
    let data = [
      {
        client_id: clientId,
        roleName: roleNames,
        email: value.email,
        userId: value.applicationRoleUserId
          ? value.applicationRoleUserId
          : value.id,
        groupName: value.name,
        type: value.type,
        groupId: value.id,
      },
    ];
    console.log(data);
    setCurrentDeleteValue(data);
    setIsdeleteOpen(true);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        muiFilterTextFieldProps: ({ column }) => {
          const value = column.getFilterValue() || "";

          return {
            helperText:
              value.trim().length > 0 && value.trim().length < 3
                ? "Minimum 3 characters required"
                : "",
            slotProps: {
              formHelperText: {
                sx: {
                  marginTop: "1.5px",
                  marginLeft: 0,
                },
              },
            },
          };
        },
      },
      {
        accessorKey: "email",
        header: "Email",
        Cell: ({ row }) => {
          const { email, isPrimaryEmail } = row.original;
          return (
            <div className="d-flex align-items-center gap-2">
              <span>{email}</span>
              {isPrimaryEmail && <span className="badge-fun">Super Admin</span>}
            </div>
          );
        },
        muiFilterTextFieldProps: ({ column }) => {
          const value = column.getFilterValue() || "";

          return {
            helperText:
              value.trim().length > 0 && value.trim().length < 3
                ? "Minimum 3 characters required"
                : "",
            slotProps: {
              formHelperText: {
                sx: {
                  marginTop: "1.5px",
                  marginLeft: 0,
                },
              },
            },
          };
        },
      },
      {
        accessorKey: "action",
        header: "Action",
        minSize: 60,
        maxSize: 60,
        size: 60,
        enableColumnActions: false,
        enableSorting: false,
        enableColumnFilter: false,
        muiTableHeadCellProps: {
          sx: {
            borderTop: "1px solid rgba(224, 224, 224, 1)",
            "& .Mui-TableHeadCell-Content-Labels": {
              paddingLeft: "0px",
              fontWeight: "400",
            },
          },
        },
        Cell: ({ row }) => (
          <span
            className={`cursor-pointer ${
              row.original.isPrimaryEmail ? "d-none" : ""
            }`}
            onClick={() => handleDelete(row.original)}
          >
            <CommonIcon fileName={"DeleteIcon"} />
          </span>
        ),
      },
    ],
    [handleDelete]
  );

  const yesActions = () => {
    setIsdeleteOpen(false);
    dispatch({ type: "IS_LOADER", data: true });
    dispatch(userRemoveTable(applicationId, rolebasedId, currentDeleteValue))
      .then((res) => {
        fetchDetails(applicationId);
        handleDataFetch(
          currentFilters.pageSize,
          currentFilters.pageIndex,
          currentFilters.columnFilter,
          currentFilters.sortingFilters
        );
        // this.customToast("Deleted successfully");
      })
      .catch((error) => {
        console.log(error);
        dispatch({ type: "IS_LOADER", data: false });
      });
  };

  const noActions = () => {
    setIsdeleteOpen(false);
    setCurrentDeleteValue(null);
  };

  const handleDataFetch = (pageSize, pageIndex, columnsFilters, sorting) => {
    // this.setState({
    //   pageSize: pageSize,
    //   pageIndex: pageIndex,
    //   columnFilter: columnsFilters,
    //   sortingFilters: sorting,
    // });
    setCurrentFilters({
      pageSize: pageSize,
      pageIndex: pageIndex,
      columnFilter: columnsFilters,
      sortingFilters: sorting,
    });

    const filterObject = columnsFilters.reduce((acc, curr) => {
      acc[curr.id] = curr.value;
      return acc;
    }, {});
    let sortorder = !sorting[0]?.desc;
    let data = {
      Name: filterObject.name
        ? filterObject.name?.trim().length >= 3
          ? filterObject.name?.trim()
          : ""
        : "",
      Email: filterObject.email
        ? filterObject.email?.trim().length >= 3
          ? filterObject.email?.trim()
          : ""
        : "",
      SortBy: sorting[0]?.id ?? "name",
      SortOrder: sortorder ? "asc" : "desc",
      PageNumber: pageSize + 1,
      PageSize: pageIndex,
    };

    getRoleData(data);
  };

  const getRoleData = (data) => {
    setTableLoader(true);
    dispatch(roleBasedUsers(applicationId, rolebasedId, data))
      .then((res) => {
        setTableLoader(false);
        steRoleBasedUserData(res.data);
        // this.setState({ rolebasedtableuser: res.data });
        // this.setState(
        //   (prev) => ({
        //     totalCount: res.pagination.totalCount,
        //     totalPages: res.pagination.totalPages,
        //     currentPage: res.pagination.currentPage,
        //     filter: {
        //       ...prev.filters,
        //       PageSize: res.pagination.pageSize,
        //     },
        //   }),
        //   () => {
        //     console.log(
        //       this.state.filters.pageNumber,
        //       this.state.filters.PageSize,
        //       this.state.currentPage
        //     );
        //   }
        // );
      })
      .catch((error) => {
        setTableLoader(false);
        console.log(error);
        // this.setState({ tableLoader: false });
      });
  };

  const handleChangeTable = (e, newVal) => {
    setRolebasedId(newVal);
  };

  const cancelSubscription = () => {
    alert("Cancel Subscription clicked");
  };

  const closesearch = () => {
    setSearch(false);
    setSearchInput("");
  };

  const filtersearch = () => {
    alert("Search triggered with: " + searchInput);
  };

  const newUserGroupFormShow = () => {
    alert("Add button clicked");
  };

  return (
    <>
      <div className="row ps-1">
        {/* ----------- Trial Licenses Section ----------- */}
        <div className="col-12 col-md-4 col-xl-2 col-lg-3">
          <h3 className="licenseheader">Trial Licenses</h3>
        </div>

        <div className="col-12 col-xl-10 col-lg-9 col-md-8 pt-0">
          <div className="col-12">
            <div className="d-flex align-items-start">
              <FormLabel className="formlabel-style1">Licenses</FormLabel>
              <span className="formlabel-input">
                &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;{totalLicense}
              </span>
            </div>
          </div>

          <div className="col-12">
            <div className="d-flex align-items-start">
              <FormLabel className="formlabel-style1">Assigned</FormLabel>
              <span className="formlabel-input">
                &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;{assignedLicenses} /{" "}
                {totalLicense}
              </span>
            </div>
          </div>

          <div className="d-flex">
            <button className="btn-fun disabled ps-3 p-2 pe-3 fs-7 mt-2">
              Assign Licenses
            </button>
            <button className="disabled btn-fun ps-3 p-2 pe-3 fs-7 mt-2">
              Start a paid subscription now
            </button>
          </div>
        </div>
      </div>

      <hr className="hrproducts" />

      {/* ----------- Subscription Section ----------- */}
      <div className="row ps-1">
        <div className="col-12 col-md-4 col-xl-2 col-lg-3">
          <h3 className="licenseheader">Subscription</h3>
        </div>

        <div className="col-12 col-xl-10 col-lg-9 col-md-8 pt-0">
          <div className="col-12 mb-0">
            <div className="d-flex align-items-start">
              <FormLabel className="formlabel-style1">Status</FormLabel>
              <FormLabel className="px-2">-</FormLabel>
              <span
                className={`formlabel-input12 ${
                  subscriptionStatus === "Subscribed" ||
                  subscriptionStatus === "Trial"
                    ? "text-success"
                    : "reporttext12un"
                }`}
              >
                Active
              </span>
            </div>
          </div>
        </div>
      </div>

      <hr className="hrproducts mb-1" />

      {/* ----------- Licensed Users Section ----------- */}
      <div className="container-fluid">
        <div className="row ps-1 d-flex align-items-center">
          <div className="col-12 ps-0 ms-0 col-md-4 col-xl-2 col-lg-3 mb-3 mb-md-0">
            <h3 className="licenseheader mt-2">Licensed users</h3>
          </div>

          <div className="col-12 col-md-12 col-xl-10 col-lg-9 ps-1 pe-0 mt-0 pt-0">
            <Box sx={{ width: "100%", padding: 0 }}>
              <div className="d-flex justify-content-between">
                <Tabs
                  value={rolebasedId}
                  onChange={handleChangeTable}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                >
                  {applicationroles.map((e) => (
                    <Tab
                      key={e.id}
                      label={e.displayName}
                      value={e.id}
                      sx={{ textTransform: "none" }}
                      className="m1 p0 mr-20"
                    />
                  ))}
                </Tabs>

                <div className="d-flex align-items-center ms-2">
                  <div className="d-flex align-items-center">
                    <button
                      className="btn-fun ps-3 p-2 pe-3 fs-7 ms-2 me-0 d-flex align-items-center"
                      onClick={() => setIsAddOpen(true)}
                    >
                      <CommonIcon fileName={"AddPlus1"} /> Assign
                    </button>
                  </div>
                </div>
              </div>
            </Box>
          </div>
        </div>
      </div>

      {/* ----------- Table Placeholder ----------- */}
      <div className="row mt-2">
        <div className="col-12 col-xl-2 col-lg-3 col-md-12"></div>
        <div className="col-12 col-xl-10 col-lg-9 col-md-12">
          {/* <div className="p-2 border mt-2">
            <strong>Dummy Table:</strong>
            {rolebasedtableuser.map((u) => (
              <div key={u.id} className="border-bottom py-1">
                {u.name} — {u.role}
              </div>
            ))}
          </div> */}
          {isDataFetched && (
            <CustomListViewSub
              listData={roleBasedUsersData || []}
              columns={columns}
              handleDataFetch={handleDataFetch}
              totalCount={0}
              isLoading={tableLoader}
            />
          )}
        </div>
      </div>
      <div
        className={
          "offcanvas offcanvas-end custom-offcanvas" +
          (isAddOpen ? " show" : "")
        }
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="true"
        id="AddGrouporrole"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div
          className={`offcanvas-header d-flex align-items-center  pe-4 pt-2`}
        >
          <span className="headername3 px-3">Assign User</span>
          <button
            data-bs-dismiss="offcanvas"
            className="offcavasclose"
            onClick={() => {
              closeUserGroupForm();
            }}
          >
            <CommonIcon fileName={"Close"} />
          </button>
        </div>

        <div className="offcanvas-body pt-0" style={{ overflow: "hidden" }}>
          {availableLicense > 0 ? (
            <>
              <div className="row" style={{ padding: "0rem 1rem" }}>
                <div className="col-12  flex-1">
                  <FormLabel className="formlabel-style1">
                    {/* Assign user */}User
                  </FormLabel>
                  <div className="d-flex align-items-center justify-content-start col-lg-12 col-md-12 col-sm-12 pt-0 ps-0">
                    <Autocomplete
                      className="col-12"
                      error={userError}
                      id="autocom"
                      multiple // Enable multi-select
                      options={unassignedUsers}
                      getOptionLabel={(option) =>
                        `${option.email ? option.email : option.name}`
                      }
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "12px",
                          }}
                        >
                          <Avatar
                            sx={{ width: 35, height: 35, marginRight: 2 }}
                          >
                            {option.name.charAt(0)}
                          </Avatar>
                          <div>
                            <strong>{option.name}</strong>
                            <div>{option.email}</div>
                          </div>
                        </li>
                      )}
                      value={selectedUserssss} // Changed from `selectedUser` to `selectedUsers` to support multiple selections
                      onChange={handleUserChange}
                      renderInput={(params) => (
                        <div className="d-flex">
                          <TextField
                            error={userError}
                            helperText={userError ? "Please select a user" : ""}
                            className="addadmininput"
                            id="textin"
                            {...params}
                            variant="filled"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: null, // Removes the dropdown arrow
                              sx: {
                                height: "max-content",
                                "& .MuiAutocomplete-popupIndicator": {
                                  display: "none", // Ensure any popup indicator is hidden
                                },
                              },
                              inputProps: {
                                ...params.inputProps,
                                style: {
                                  padding: 0,
                                  height: "100%",
                                  display: "flex",
                                  paddingBottom: "20px",
                                },
                              },
                            }}
                          />
                        </div>
                      )}
                      sx={{ width: "100%", marginRight: 2 }}
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-3" style={{ padding: "0rem 1rem" }}>
                <div className="col-12">
                  <FormControl fullWidth sx={{ width: "100%" }}>
                    <FormLabel className="formlabel-style1">
                      Select a role
                    </FormLabel>
                    <RadioGroup
                      row
                      value={rolebasedId}
                      onChange={(e) => {
                        const selectedId = e.target.value;

                        const selectedRole = applicationroles.find(
                          (role) => role.id === selectedId
                        );
                        setRolebasedId(selectedId);
                      }}
                    >
                      {applicationroles.map((role) => (
                        <FormControlLabel
                          key={role.id}
                          value={role.id}
                          control={<Radio />}
                          label={role.name}
                          sx={{
                            marginLeft: 0,
                            marginRight: 0, // removes extra left margin
                            paddingLeft: 0, // removes left padding
                            ".MuiRadio-root": {
                              padding: 1,
                              marginLeft:-1
                            },
                          }}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-12 mt-1 pb-20 pr-28 ml-19 ps-2">
                  <button
                    onClick={AssignRoles}
                    className="btn-fun ps-4 pe-4 fs-7"
                  >
                    Assign User
                  </button>
                  &nbsp;&nbsp;
                </div>
              </div>
            </>
          ) : (
            <div>
              <h3 className="nolicensewarning ps-3">
                No license available. Please increase required licenses to add
                new users.
              </h3>
            </div>
          )}

          <div>
            <div className={`col-12 `}></div>
          </div>
        </div>
      </div>
      <div
        className={`modal modal-style ${isDeleteOpen ? "show" : ""}`}
        id="deletemodal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{
          display: isDeleteOpen ? "block" : "none",
          zIndex: "1070",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content shadow-lg bg-white rounded">
            <div className="modal-body text-center">
              <CommonIcon fileName={"deletemember"} />
              <br />
              <span>Are you sure, you want to delete this user?</span>
            </div>
            <div className="modal-footer justify-content-center">
              <Button
                className="btn-no px-4"
                variant="primary"
                onClick={() => {
                  noActions();
                }}
              >
                No
              </Button>{" "}
              <Button
                className="btn-action px-4"
                variant="primary"
                onClick={() => {
                  yesActions();
                }}
              >
                Yes
              </Button>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
